import * as React from 'react';
import { FilterableMenuItem, FilterableMenuItemArgs, DisplayOption } from 'owa-filterable-menu';
import LockCanvasMenuItem from './LockCanvasMenuItem';

const TOGGLE_CANVAS_LOCK = 'TOGGLE_CANVAS_LOCK';

export default function getLockCanvasMenuItem() {
    return new FilterableMenuItem({
        [FilterableMenuItemArgs.id]: TOGGLE_CANVAS_LOCK,
        [FilterableMenuItemArgs.key]: TOGGLE_CANVAS_LOCK,
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
        [FilterableMenuItemArgs.onRender]: () => <LockCanvasMenuItem />,
    });
}
